<div dropdown class="dropdown" aria-haspopup="true" [dropup]="isDropup" (isOpenChange)="uparrow=!uparrow">
    <div dropdownToggle class="topbar-item" data-toggle="dropdown" data-offset="10px,0px" aria-expanded="false">
        <div [class]=" ">
            <div [class]="textCssClass" pTooltip="{{profileName}}" [tooltipDisabled]="DisableTooltip(profileName, 16)" tooltipPosition="bottom">
                {{ userFullname( profileName ) | slice:0:15}}{{userFullname( profileName ).length > 15 ? '...' : '' }}
            </div>
            <div class="la maginIcon cursor-pointer" [ngClass]=" uparrow ? 'la-angle-up' : 'la-angle-down'">
                <img  [src]="imgPath ? imgPath : 'assets/common/images/default-profile-picture1.svg'" [class]="symbolTextCssClass" class="w-35px h-35px border border-light rounded p-1 ml-3" id="profimgsize" />
                <!-- <img *ngIf="imgPath == ''" [class]="symbolTextCssClass" class="w-35px h-35px ml-3" style="background-repeat:no-repeat; background-size:contain; background-position: center; background-image: url('assets/common/images/default-profile-picture1.svg')" /> -->
            </div>

        </div>
    </div>
    <div *dropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-right dropdown-menu-lg transformMenu" [attr.aria-label]="l('Languages')">
        <perfect-scrollbar>

            <div id="userMenuComp" class="d-flex flex-column pt-3 pl-9 pb-8 bgi-size-cover bgi-no-repeat rounded-top  bgColorForUserMenu">
                 <div class="navi mt-2">
                    <div class=" text-white font-size-h3-sm">
                        {{"MyProfile" | localize}}
                    </div>
                </div>
                <div class="d-flex align-items-center mt-3">
                    <div class="symbol symbol-70 mr-5">

                        <div class="symbol-label">
                            <img class="symbol-label" style="background-repeat:no-repeat; background-size:contain; background-position: center;"
                                 [src]=" imgPath? imgPath : 'assets/common/images/default-profile-picture1.svg'" />
                         <!--   <img *ngIf="imgPath !=''" [src]="imgPath" class="symbol-label" />
                            <img *ngIf="imgPath == '' || imgPath == null" class="symbol-label" style="background-repeat:no-repeat; background-size:contain; background-position: center; background-image: url('assets/common/images/default-profile-picture1.svg')" />-->
                        </div>


                    </div>
                    <div class="d-flex flex-column">


                        <div class="font-weight-bold font-size-h5 text-white topbar-username" pTooltip="{{profileName}}" [tooltipDisabled]="DisableTooltip(profileName, 16)" tooltipPosition="bottom">
                            {{ userFullname( profileName ) | slice:0:15}}{{userFullname( profileName ).length > 15 ? '...' : '' }}
                        </div>
                        <div class="font-weight-bold font-size-sm text-white topbar-username">
                          <span *ngIf="myProfileData.employeeId">{{myProfileData.employeeId}} | </span>
                          <!-- {{myProfileData?.roleName?.toString().replace(',' , ', ') }}{{myProfileData?.roleName?.length > 15 ? '...' : '' }}  -->
                          <span  pTooltip="{{myProfileData?.roleName?.toString().replace(',' , ', ') }}"  [tooltipDisabled]="DisableTooltip(myProfileData?.roleName?.toString().replace(',' , ', '), 16)"  tooltipPosition="bottom">
                            {{ (myProfileData?.roleName?.toString().replace(',' , ', ')).slice(0, 16) }}{{ myProfileData?.roleName?.toString().replace(',' , ', ').length > 16 ? '...' : '' }}
                          </span>
                        </div>
                        <div class="font-weight-bold font-size-sm text-white topbar-username" pTooltip="{{myProfileData.emailAddress}}"
                            [tooltipDisabled]="DisableTooltip(myProfileData.emailAddress, 25)" tooltipPosition="bottom">
                            {{myProfileData.emailAddress| slice:0:25}}{{myProfileData.emailAddress.length > 25 ? '...' :
                            '' }}
                        </div>

                    </div>
                </div>
            </div>
            <div class="navi navi-hover my-4 ps">

                <a Class="navi-item cursor-pointer" (click)="getMyProfile()">
                    <div class="navi-link">
                        <div class="navi-icon mr-2">
                            <img [src]="appRootUrl() + 'assets/common/images/header/My-Profile.svg'" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="font-weight-bold">
                                {{"MyProfile" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
                <a Class="navi-item cursor-pointer" (click)="logout()">
                    <div class="navi-link">
                        <div class="navi-icon mr-2">
                            <img [src]="appRootUrl() + 'assets/common/images/header/Log-Out.svg'" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="font-weight-bold">
                                {{"Logout" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>

        </perfect-scrollbar>
    </div>
</div>
